module.exports = __webpack_public_path__ + "static/ashen_rider-93cfb52aec9dc973b5240973bf087c67.jpg";